import { TextBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useBrokerNewReferralStore } from '../../../state/useBrokerNewReferralStore';

interface RepresentativeLastNameProps {
    required?: boolean;
    onValidationEvent: (isValid: boolean) => void;
}

export const RepresentativeLastName: React.FC<RepresentativeLastNameProps> = ({ required = false, onValidationEvent }) => {
    const isMobile = isMobileScreen();
    const label = 'Last Name';
    const value = useBrokerNewReferralStore((s) => s.referral.repLastName);
    const setValue = useBrokerNewReferralStore((s) => s.set_repLastName);

    return (
        <>
            <TextBox
                id='representativeLastNameTextBox'
                value={value}
                onChange={(newValue) => setValue(newValue)}
                label={label}
                required={required}
                width={isMobile ? '100%' : '200px'}
                onValidationEvent={onValidationEvent}
            />
        </>
    );
};
